import React, { useState } from 'react';
import { css } from "@emotion/core";
import PuffLoader from "react-spinners/PuffLoader";
import LoadingPage from '../../pages/loading';

export default function ConstructionPage() {
  const [sourceLoaded, setSourceLoaded] = useState(false);
  const IMAGE_SRC = '/images/maintenance.gif';

  const img = new Image();
  img.src = IMAGE_SRC;
  img.onload = () => setSourceLoaded(true);

  React.useEffect(() => {
    document.title = "Shems Almadina - Page en Construction"
    return () => {
      document.title = "Shems Almadina"
    };
  }, []);
  return sourceLoaded ? <div style={{height: "80vh"}}><div style={{position: "absolute", left: "50%", top: "80px", transform: "translateX(-50%)"}}>
      <img src={IMAGE_SRC} style={{width: "250px"}} />
      <p style={{textAlign: "center", fontWeight: 600, fontSize: "larger"}}>Page en Construction...</p>
    </div></div> : <LoadingPage />;
}
